<template>
  <div class="base-upload">
    <div class="img-upload">
      <div class="handler">
        <Upload
          ref="baseUpload"
          style="margin-top: 20px"
          :before-upload="handleBeforeUpload"
          :show-upload-list="false"
          :on-success="uploadSuccess"
          :on-error="uploadError"
          :data="uploadData"
          accept="image/*"
          :format="['jpg', 'jpeg', 'png']"
          :on-format-error="FormatError"
          :action="actionUrl"
        >
          <Button type="text" ghost>点击上传</Button>
        </Upload>
      </div>
    </div>
  </div>
</template>

<script>
// import { uploadUrl } from '@/common/js/config'
import { getUploadToken } from "@/common/js/util";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      file: null,
      addHeaders: null,
      fileId: "",
      uploadData: {},
      actionUrl: "//up-z1.qiniup.com"
    };
  },
  methods: {
    handleBeforeUpload(file) {
      this.file = file;
      getUploadToken(data => {
        this.uploadData = {
          token: data.token
        };
        this.$nextTick(() => {
          this.$refs.baseUpload.post(this.file);
        });
      });
      return false;
    },
    uploadSuccess(data) {
      this.fileId = data.key;
      this.$emit("uploadSuccess", {
        key: data.key,
        name: this.file.name
      });
    },
    uploadError() {
      this.warningInfo("图片上传失败");
    },
    FormatError() {
      this.warningInfo("图片格式不正确");
    },
    MaxSize() {
      this.warningInfo("图片大小超出限制");
    }
  }
};
</script>

<style lang="less" scoped>
.img-upload {
  display: flex;
  align-items: center;
  margin: 20px 0;
  .img-wrapper {
    position: relative;
    flex-basis: 120px;
    width: 120px;
    height: 120px;
    overflow: hidden;
    background: #ccc;
    img {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .handler {
    padding-left: 15px;
    &-tip {
      margin-bottom: 5px;
      color: #555;
      font-size: 16px;
    }
  }
}
.img-cur {
  cursor: pointer;
}
</style>
